import type { ApiModuleEndpoints } from '../types'
export const customerApiEndpoints = {
  list: { method: 'GET', path: '/customers', requiresAuth: true },
  options: { method: 'GET', path: '/customers/options', requiresAuth: true },
  detail: { method: 'GET', path: '/customers/:id', requiresAuth: true },
  create: { method: 'POST', path: '/customers', requiresAuth: true },
  quickCreate: { method: 'POST', path: '/customers/quick-create', requiresAuth: true },
  update: { method: 'PUT', path: '/customers/:id', requiresAuth: true },
  delete: { method: 'DELETE', path: '/customers/:id', requiresAuth: true },
  invoices: { method: 'GET', path: '/customers/:id/invoices', requiresAuth: true },
  ledger: { method: 'GET', path: '/customers/:id/ledger', requiresAuth: true },
  tierHistory: { method: 'GET', path: '/customers/:id/tier-history', requiresAuth: true },
  groups: { method: 'GET', path: '/customer-groups', requiresAuth: true },
  groupOptions: { method: 'GET', path: '/customer-groups/options', requiresAuth: true },
  createGroup: { method: 'POST', path: '/customer-groups', requiresAuth: true },
  updateGroup: { method: 'PUT', path: '/customer-groups/:id', requiresAuth: true },
  deleteGroup: { method: 'DELETE', path: '/customer-groups/:id', requiresAuth: true },
  tiers: { method: 'GET', path: '/membership-tiers', requiresAuth: true },
  tierOptions: { method: 'GET', path: '/membership-tiers/options', requiresAuth: true },
  createTier: { method: 'POST', path: '/membership-tiers', requiresAuth: true },
  updateTier: { method: 'PUT', path: '/membership-tiers/:id', requiresAuth: true },
  deleteTier: { method: 'DELETE', path: '/membership-tiers/:id', requiresAuth: true },
  debts: { method: 'GET', path: '/customer-debts', requiresAuth: true },
  debtDetail: { method: 'GET', path: '/customer-debts/:id', requiresAuth: true },
  createReceipt: { method: 'POST', path: '/customer-receipts', requiresAuth: true },
  receipts: { method: 'GET', path: '/customer-receipts', requiresAuth: true },
  cancelReceipt: { method: 'POST', path: '/customer-receipts/:id/cancel', requiresAuth: true },
  pointPolicy: { method: 'GET', path: '/loyalty/point-policy', requiresAuth: true },
  createPointPolicy: { method: 'POST', path: '/loyalty/point-policy', requiresAuth: true },
  updatePointPolicy: { method: 'PUT', path: '/loyalty/point-policy/:id', requiresAuth: true },
  activatePointPolicy: {
    method: 'POST',
    path: '/loyalty/point-policy/:id/activate',
    requiresAuth: true,
  },
  pausePointPolicy: { method: 'POST', path: '/loyalty/point-policy/:id/pause', requiresAuth: true },
  points: { method: 'GET', path: '/customers/:id/points', requiresAuth: true },
  pointsLedger: { method: 'GET', path: '/customers/:id/points/ledger', requiresAuth: true },
  adjustPoints: { method: 'POST', path: '/customers/:id/points/adjustments', requiresAuth: true },
} as const satisfies ApiModuleEndpoints
